import { render } from "./Divider.vue?vue&type=template&id=57b8f3aa&scoped=true&ts=true"
import script from "./Divider.vue?vue&type=script&lang=ts"
export * from "./Divider.vue?vue&type=script&lang=ts"

import "./Divider.vue?vue&type=style&index=0&id=57b8f3aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b8f3aa"]])

export default __exports__